import Slide from "@mui/material/Slide";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { AvForm } from "availity-reactstrap-validation";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Switch from "@material-ui/core/Switch";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

const label = { inputProps: { "aria-label": "Switch demo" } };

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function HostManagement(props) {
  const { uniqname, uniqnamelen, selectedIds, open1, setOpen1 } = props;

  const [open, setOpen] = React.useState(false);

  const [opensche, setOpensche] = React.useState(false);

  const handleClickOpensche = () => {
    if (opensche) {
      setOpensche(false);
    } else {
      setOpensche(true);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOpensche(false);
  };

  const [selectedtemp, setSelectedtemp] = useState({
    temp_id: "",
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setSelectedtemp((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const [hostinfo, setHostinfo] = React.useState([]);

  React.useEffect(() => {
    const HostID = selectedIds[0];
    fetch(`${process.env.REACT_APP_API_URL}/api/hosts/${HostID}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          setHostinfo(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, [props.selectedIds]);

  const [templist, settemplist] = React.useState([]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/organizationtemplateslist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          settemplist(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const Audit = (selectedIds) => (e) => {
    e.preventDefault();
    selectedIds.map((val) => {
      const data = {
        host_id: val.toString(),
        temp_id: selectedtemp.temp_id.toString(),
      };
      fetch(`${process.env.REACT_APP_API_URL}/api/run_audit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          window.location.href = "/admin/audit";
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
          window.location.href = "/admin/hostmanagement";
        });
    });
    setOpen(false);
  };

  return (
    <>
      {uniqnamelen <= 1 ? (
        <button
          className={
            selectedIds.length > 0
              ? "bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold text-xs px-2 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              : "bg-lightBlue-200 text-white active:bg-lightBlue-600 font-bold text-xs px-2 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          }
          type="button"
          disabled={selectedIds.length > 0 ? false : true}
          onClick={handleClickOpen}
        >
          Run Audit
        </button>
      ) : (
        <button
          className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold text-xs px-2 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          type="button"
          disabled={open1}
          onClick={() => {
            setOpen1(true);
          }}
        >
          Run Audit
        </button>
      )}
      <BootstrapDialog
        // onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          RUN AUDIT
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>Compliance Profile</Typography>
          <TextField
            type="select"
            id="temp_id"
            className="form-control"
            onChange={handleChange}
            placeholder="-- Select the Compliance Profile --"
            variant="outlined"
            size="small"
            select
            SelectProps={{ native: true }}
            fullWidth
          >
            <option selected disabled>
              -- Select the Compliance Profile --
            </option>
            <optgroup label="Operating System" key="server">
              {templist
                .filter(
                  (temp) =>
                    temp.os_type === hostinfo.platform && temp.key === "OS"
                )
                .map((filtertemp) => {
                  return (
                    <React.Fragment>
                      <option value={filtertemp.id}>
                        {`${filtertemp.name} ${filtertemp.compliance}`}
                      </option>
                    </React.Fragment>
                  );
                })}
            </optgroup>
            {hostinfo.os_type === "linux" ? (
              <optgroup label="Application" key="application">
                {templist
                  .filter((temp) => temp.key === "Application-Linux")
                  .map((filtertemp) => {
                    return (
                      <React.Fragment>
                        <option value={filtertemp.id}>
                          {`${filtertemp.name} ${filtertemp.compliance}`}
                        </option>
                      </React.Fragment>
                    );
                  })}
              </optgroup>
            ) : (
              <optgroup label="Application" key="application">
                {templist
                  .filter((temp) => temp.key === "Application-Windows")
                  .map((filtertemp) => {
                    return (
                      <React.Fragment>
                        <option value={filtertemp.id}>
                          {`${filtertemp.name} ${filtertemp.compliance}`}
                        </option>
                      </React.Fragment>
                    );
                  })}
              </optgroup>
            )}
          </TextField>
          <br />
          <br />
        </DialogContent>
        <DialogActions>
          <button
            className=" text-white active:bg-lightBlue-600 font-bold text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="button"
            onClick={handleClose}
            style={{ color: "#0ea5e9" }}
          >
            cancel
          </button>
          <button
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="button"
            onClick={Audit(selectedIds)}
          >
            <Link to="/admin/audit" style={{ color: "#FFF" }}>
              Run Audit
            </Link>
          </button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}
